/**
 * Count bits that are set to 1 in a 32-bit number.
 * @param value Number to count
 */
export function bitCount32(value: number) {
  value = value - ((value >> 1) & 0x55555555);
  value = (value & 0x33333333) + ((value >> 2) & 0x33333333);
  return (((value + (value >> 4)) & 0xf0f0f0f) * 0x1010101) >> 24;
}

export function bitCheck(a: number, bitIndex: number): boolean {
  return ((a >> bitIndex) & 1) !== 0;
}

export function bitSetTo(a: number, bitIndex: number, bitValue: boolean): number {
  return (a & ~(1 << bitIndex)) | ((bitValue ? 1 : 0) << bitIndex);
}

/**
 * Remove bit with index i from bitmask and shift all the higher bits down.
 * @param mask Bitmask
 * @param i Index of the bit that is removed.
 * @returns Mask with the bit i removed.
 */
export function spliceBitmask(mask: number, i: number): number {
  const lowerBits = mask & ((1 << i) - 1);
  const higherBitsShifted = (mask & ~((1 << (i + 1)) - 1)) >> 1;
  return lowerBits | higherBitsShifted;
}
